module.exports = __webpack_public_path__ + "static/img/4.c58671f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wepb/4.webp
// module id = im2s
// module chunks = 1